"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBoundingClientRect = void 0;
var _react = require("react");
var _debounce = require("@cbhq/cds-common/utils/debounce");
var _mockUtils = require("@cbhq/cds-common/utils/mockUtils");
var _browser = require("../utils/browser");
var _useIsoEffect = require("./useIsoEffect");
const defaultValue = {
  bottom: 0,
  height: 0,
  left: 0,
  right: 0,
  top: 0,
  width: 0,
  x: 0,
  y: 0,
  toJSON: _mockUtils.NoopFn
};
const useBoundingClientRect = ref => {
  var _ref$current$getBound, _ref$current;
  const rectRef = (0, _react.useRef)((_ref$current$getBound = (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.getBoundingClientRect()) !== null && _ref$current$getBound !== void 0 ? _ref$current$getBound : defaultValue);
  const handleResize = (0, _react.useCallback)(() => {
    if (ref.current) {
      var _ref$current2;
      rectRef.current = (_ref$current2 = ref.current) === null || _ref$current2 === void 0 ? void 0 : _ref$current2.getBoundingClientRect();
    }
  }, [ref]);
  const debouncedResize = (0, _debounce.debounce)(handleResize, 200);
  (0, _useIsoEffect.useIsoEffect)(() => {
    var _getBrowserGlobals;
    if (ref.current) {
      debouncedResize();
    }
    if ((0, _browser.isSSR)()) {
      return undefined;
    }
    (_getBrowserGlobals = (0, _browser.getBrowserGlobals)()) === null || _getBrowserGlobals === void 0 ? void 0 : _getBrowserGlobals.window.addEventListener('resize', debouncedResize);
    return () => {
      var _getBrowserGlobals2;
      return (_getBrowserGlobals2 = (0, _browser.getBrowserGlobals)()) === null || _getBrowserGlobals2 === void 0 ? void 0 : _getBrowserGlobals2.window.removeEventListener('resize', debouncedResize);
    };
  }, [ref, debouncedResize]);
  return rectRef.current;
};
exports.useBoundingClientRect = useBoundingClientRect;